export default () => ({
  bankId: {
    type: 'select',
    label: 'Banco',
    placeholder: 'Banco',
    searchable: true,
    options: [],
    displayBy: 'name',
    trackBy: 'id',
    infoCardProps: { hide: true },
  },

  accountType: {
    type: 'select',
    options: [],
    displayBy: 'name',
    trackBy: 'id',
    label: 'Tipo de conta',
    placeholder: 'Tipo de conta',
  },

  modality: {
    type: 'select',
    options: [
      { label: 'Pessoa Física', value: 'PF' },
      { label: 'Pessoa Jurídica', value: 'PJ' },
    ],
    displayBy: 'label',
    trackBy: 'value',
    label: 'Modalidade',
    placeholder: 'Modalidade',
    infoCardProps: { hide: true },
  },

  agency: {
    type: 'text',
    label: 'Agência',
    inputmode: 'numeric',
    placeholder: 'Agência',
    validation: { max: 10, min: 3 },
    mask: '##########',
    validationMsg: 'Agência deve ter de 3 a 10 dígitos',
    emitPreValidation: true,
  },

  account: {
    type: 'text',
    label: 'Conta',
    placeholder: 'Conta',
    inputmode: 'numeric',
    validation: { min: 4, max: 20 },
    mask: '####################',
    validationMsg: 'Conta deve ter de 4 a 20 dígitos',
    emitPreValidation: true,
  },

  accountDigit: {
    type: 'text',
    label: 'Dígito da Conta',
    placeholder: 'Dígito da Conta',
    validation: { max: 4 },
    mask: 'XXXX',
    validationMsg: 'Dígito da conta deve ter no máximo 4 dígitos',
    infoCardProps: { hide: true },
    emitPreValidation: true,
  },

  pix: {
    type: 'text',
    label: 'Chave PIX',
    placeholder: 'Chave PIX',
    validationMsg: 'Chave PIX deve ter de 7 a 106 caracteres',
    validation: { min: 7, max: 106 },
    emitPreValidation: true,
  },

  documentFiles: {
    type: 'file',
    label: '',
    showLabel: false,
    multiple: true,
    labelLeft: false,
    fullWidth: true,
    extensions: [
      'jpg',
      'jpeg',
      'gif',
      'bmp',
      'png',
      'pdf',
    ],
    infoCardProps: { hide: true },
    fileLimit: 4,
    validation: { maxLength: 4 },
    sizeLimit: 8,
  },
})
